'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002414 from "./presto.-Freemium2-F-A-Add-View$$anon$14.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002416 from "./presto.-Freemium2-F-A-Add-View$$anon$16.js";
import * as $j_presto$002etypes$0024$002dConfigure2$002dF$002dA$002dFreemium$002dResponse$0024 from "./presto.types$-Configure2-F-A-Freemium-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_Freemium2FAAddView$$anon$13() {
  this.aUw = null;
  this.aUo = null;
  this.aUp = false;
  this.aUx = null;
  this.aUy = false;
  this.aUB = null;
  this.aUu = null;
  this.aUv = false;
  this.aUq = null;
  this.aUr = false;
  this.aUs = null;
  this.aUt = false;
  this.aUz = false;
  this.aUA = false;
  this.aUw = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aUB = "Configure2FAFreemiumResponse";
}
export { $c_Lpresto_Freemium2FAAddView$$anon$13 as $c_Lpresto_Freemium2FAAddView$$anon$13 };
$p = $c_Lpresto_Freemium2FAAddView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Freemium2FAAddView$$anon$13;
/** @constructor */
function $h_Lpresto_Freemium2FAAddView$$anon$13() {
}
export { $h_Lpresto_Freemium2FAAddView$$anon$13 as $h_Lpresto_Freemium2FAAddView$$anon$13 };
$h_Lpresto_Freemium2FAAddView$$anon$13.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aUw;
});
$p.M = (function() {
  if ((!this.aUp)) {
    this.aUo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aUp = true;
  }
  return this.aUo;
});
$p.O = (function() {
  if ((!this.aUy)) {
    this.aUx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aUy = true;
  }
  return this.aUx;
});
$p.E = (function() {
  return this.aUB;
});
$p.t = (function() {
  if ((!this.aUv)) {
    this.aUu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("results", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aUv = true;
  }
  return this.aUu;
});
$p.N = (function() {
  if ((!this.aUr)) {
    this.aUq = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002414.$c_Lpresto_Freemium2FAAddView$$anon$14())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aUr = true;
  }
  return this.aUq;
});
$p.Q = (function() {
  if ((!this.aUt)) {
    this.aUs = new $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dView$0024$0024anon$002416.$c_Lpresto_Freemium2FAAddView$$anon$16();
    this.aUt = true;
  }
  return this.aUs;
});
$p.v = (function() {
  if ((!this.aUA)) {
    this.aUz = false;
    this.aUA = true;
  }
  return this.aUz;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee137) => ((p) => \u03b4scrutinee137.cFJ(p)))($j_presto$002etypes$0024$002dConfigure2$002dF$002dA$002dFreemium$002dResponse$0024.$m_Lpresto_types$Configure2FAFreemiumResponse$())));
});
var $d_Lpresto_Freemium2FAAddView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Freemium2FAAddView$$anon$13, "presto.Freemium2FAAddView$$anon$13", ({
  Je: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Freemium2FAAddView$$anon$13 as $d_Lpresto_Freemium2FAAddView$$anon$13 };
//# sourceMappingURL=presto.-Freemium2-F-A-Add-View$$anon$13.js.map
